import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import React, { useState } from 'react';
import {
  Box,
  useTheme,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';

import loadable from '@loadable/component';
import { Link } from 'gatsby-theme-material-ui';

const HidingFooter = loadable(() =>
  import('../../components/hiding-footer/hiding-footer')
);

const useStyles = makeStyles(({ typography, spacing }: Theme) =>
  createStyles({
    container: {
      position: 'absolute',
      width: '100%',
    },
    logo: {
      marginTop: spacing(10),
      marginLeft: spacing(12.5),
    },
    infoSection: {
      display: 'flex',
      paddingTop: spacing(12.5),
      width: '100%',
      justifyContent: 'center',
    },
    headingsContainer: {
      display: 'flex',
      justify: 'space-between',
      overflowX: 'hidden',
      maxWidth: '1113px',
    },
    heading1: {
      ...typography.h2,
      minWidth: '610px',
    },
    heading2: {
      ...typography.h6,
      width: '556px',
    },
  })
);

const HeroDesktop = () => {
  const theme = useTheme();
  const classes = useStyles();
  const handleHeroGetStarted = () => {
    trackCustomEvent({
      category: "Get Started",
      action: "Click",
      label: "Get Started - Hero",
    })
  }

  const handleBottomGetStarted = () => {
    trackCustomEvent({
      category: "Get Started",
      action: "Click",
      label: "Get Started - Bottom",
    })
  }

  return (
    <>
      <Box className={classes.container}>
        <Box pt={12.5} className={classes.infoSection}>
          <div
            className={classes.headingsContainer}
            style={{ maxWidth: '1113px' }}
          >
            <div style={{ color: theme.palette.primary.contrastText }}>
              <h1 className={classes.heading1}>
                Get Your Affordable <br />
                Personal Trainer!
              </h1>
              <Box mt={4} />
              <h2 className={classes.heading2}>
                Connect with the perfect fitness coach over the messenger,
                follow a custom-made workout tasks, and consistently get
                feedback from your trainer. All in one for an exclusive price.
              </h2>
              <Link to="/trainers/" underline="none" onClick={handleHeroGetStarted}>
                <div
                  className="mt-80 font-sans text-24 font-medium text-white flex justify-center items-center bg-dark-shade focus:outline-none hover:bg-dark rounded-lg"
                  style={{ width: 186, height: 65 }}
                >
                  Get Started
                </div>
              </Link>
            </div>
            <img
              className="mt-120"
              width="563px"
              height="419px"
              src="mockup.svg"
              alt=""
              style={{
                position: 'relative',
                left: '-70px',
                overflowX: 'hidden',
              }}
            />
          </div>
        </Box>
      </Box>

      <img
        className="w-full"
        style={{
          height: '827px',
          objectFit: 'cover',
          objectPosition: 'bottom',
        }}
        src="top-bg.svg"
        alt=""
      />
    </>
  );
};

export default HeroDesktop;
